import React, { useContext, useState } from "react";
import { IntlContext } from "react-intl";
function useDataGridEntity(columns, rows, selectedIds, getColumnsConfig) {
  const { formatMessage } = useContext(IntlContext);
  const columnsConfig = getColumnsConfig({ currency: "USD", formatMessage });
  const colDefs = columns?.map((column) => columnsConfig[column]);
  const selectedItems = rows?.filter((row) => selectedIds?.includes(row?.id));
  return { colDefs, selectedItems };
}
function useDataGridSelectedIds() {
  const [selectedIds, setSelectedIds] = useState([]);
  function handleSelect(selectedIds2) {
    setSelectedIds(selectedIds2);
  }
  return { selectedIds, handleSelect };
}
const withDataGridEntityServer = (WrappedDataGrid, getColumnsConfig) => (props) => {
  const { columns, rows, selectedIds, ...otherProps } = props;
  const { colDefs, selectedItems } = useDataGridEntity(columns, rows, selectedIds, getColumnsConfig);
  return /* @__PURE__ */ React.createElement(WrappedDataGrid, { ...otherProps, columns: colDefs, rows, selectedItems });
};
const withDataGridEntityClient = (WrappedDataGrid, getColumnsConfig) => (props) => {
  const { columns, rows, selectedIds, ...otherProps } = props;
  const { colDefs, selectedItems } = useDataGridEntity(columns, rows, selectedIds, getColumnsConfig);
  return /* @__PURE__ */ React.createElement(WrappedDataGrid, { ...otherProps, columns: colDefs, rows, selectedItems });
};
export {
  useDataGridSelectedIds,
  withDataGridEntityClient,
  withDataGridEntityServer
};
//# sourceMappingURL=DataGridEntity.js.map
